import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./css/Accelerate.css";

const Accelerate = () => {
  return (
    <div className="accelerate-section mt-5">
      <Container fluid className="py-5">
        <Row className="align-items-center">
          {/* Left Side: Text and Button */}
          <Col md={6} className="text-section">
            <h1 className="accelerate-title">
              Your career, guided by AI and real mentors—anytime, anywhere.
            </h1>
            <p className="accelerate-subtitle">
              CLIF AI offers personalized career guidance through AI-powered
              assessments and real mentorship, helping you grow at every
              stage—whether you're just starting out or planning your next big
              move. Gain clarity on your strengths, bridge skill gaps, and
              connect with experts who’ve been where you want to go. It’s your
              roadmap to a future-ready career, made simple
            </p>
            <a href="/subscription">
              <button type="button" class="btn-outline-primary login-btn">
                Get started
              </button>
            </a>
          </Col>

          {/* Right Side: Video Placeholder */}
          <Col md={6} className="video-section">
            <div className="video-placeholder hackathon-image">
              <img
                src="../../../images/individuals/3.jpg"
                alt="Chris Jackson"
                className="expert-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Accelerate;
